import React from 'react';
import classNames from 'classnames';
import { StylishNewButton } from './StylishNewButton';
import { SharedIcon } from '../../SharedIcon/SharedIcon';

export const StylishNewChip = ({
  key,
  label,
  disabled,
  handleDisable,
  handleEdit,
  handleDelete,
  children,
  handleClick,
  className,
}) => {
  return (
    <>
      <div
        className={classNames(
          'form-chip',
          {
            disabled,
            raw: !handleDisable && !handleEdit && !handleDelete,
            'has-children': !!children,
            'cursor-pointer': !!handleClick,
          },
          className
        )}
        key={key}
        {...(handleClick && {
          onClick: handleClick,
          onKeyDown: (e) => {
            // Function invoked for accessibility
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault(); // Prevent spacebar from scrolling page
              handleClick();
            }
          },
          role: 'button',
          tabIndex: 0,
          'aria-label': `Select ${label}`,
        })}
      >
        <span>{label}</span>
        <div className="inner ms-auto">
          {children}
          <ul>
            {!!handleEdit && (
              <li>
                <StylishNewButton
                  customButton
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleEdit();
                  }}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <SharedIcon
                    iconName="edit"
                    size="md"
                    color="light"
                    classes="w-100 h-100 d-flex align-items-center justify-content-center"
                  />
                </StylishNewButton>
              </li>
            )}
            {!!handleDisable && (
              <li>
                <StylishNewButton
                  customButton
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDisable();
                  }}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <SharedIcon
                    iconName={disabled ? 'visibility_off' : 'visibility'}
                    size="md"
                    color="light"
                    classes="w-100 h-100 d-flex align-items-center justify-content-center"
                  />
                </StylishNewButton>
              </li>
            )}
            {!!handleDelete && (
              <li>
                <StylishNewButton
                  customButton
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDelete();
                  }}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <SharedIcon
                    iconName="delete"
                    size="md"
                    color="light"
                    classes="w-100 h-100 d-flex align-items-center justify-content-center"
                  />
                </StylishNewButton>
              </li>
            )}
          </ul>
        </div>
      </div>
    </>
  );
};
